import { CmsObjectWithDefault } from '@components/Cms/types';

export type DateOfBirthFormCmsKey =
    | 'VerifyItsYou'
    | 'VerifyYourIdentity'
    | 'DateOfBirth'
    | 'Placeholder'
    | 'SubmitButton';

export const DateOfBirthFormCmsWithDefault: CmsObjectWithDefault<DateOfBirthFormCmsKey> = {
    VerifyItsYou: {
        cmsId: 358274,
        defaultTranslation: "Verify that it's you",
    },
    VerifyYourIdentity: {
        cmsId: 358275,
        defaultTranslation: 'Please provide your date of birth to set up your PIN.',
    },
    DateOfBirth: {
        cmsId: 358276,
        defaultTranslation: 'Date of birth',
    },
    Placeholder: {
        cmsId: 358277,
        defaultTranslation: 'DD/MM/YYYY',
    },
    SubmitButton: {
        cmsId: 358288,
        defaultTranslation: 'Submit',
    },
};
